import { SmartNotificationsSettingsResource } from '~/resources';
import { BADGE_CHECK } from '~/rails_assets';
import { SETTINGS, SETTINGS_SMART_NOTIFICATIONS, GETTING_STARTED } from '~/app_constants';
import { buildNotificationParams } from '~/utils/smartNotificationPresets';

export default {
  props: {
    notifications: {
      type: Array,
      default: () => [],
      validator: (value) => {
        return value.every((notification) => {
          const notificationKeys = Object.keys(notification);

          return ['id', 'key'].every((key) => notificationKeys.includes(key));
        });
      },
    },
    'insights-trial-started': {
      type: Boolean,
      default: false,
    },
    'insights-trial-monthly-price': {
      type: Number,
      required: true,
      validator: (value) => {
        return value > 0;
      },
    },
    'substep-status': {
      type: String,
      default: 'current',
    },
    source: {
      type: String,
      validator: (value) => {
        return ['getting_started_flow', 'insights_onboarding_flow'].includes(value);
      },
    },
    organization: {
      type: Object,
      required: true,
      validator: (value) => {
        const valueKeys = Object.keys(value);

        return valueKeys.includes('id');
      },
    },
  },
  data() {
    return {
      assets: SETTINGS.smart_notifications,
      images: GETTING_STARTED,
      dialogDismissed: false,
      BADGE_CHECK,
      submitting: [],
    };
  },
  computed: {
    showDialog() {
      return this.insightsTrialStarted && !this.dialogDismissed;
    },
    notificationTemplates() {
      if (!this.assets?.presets) {
        return {};
      }

      return Object.entries(this.assets.presets)
        .map(([key, value]) => {
          const template = { key, ...value };

          if (template.label === SETTINGS_SMART_NOTIFICATIONS.presets.high_activity.label) {
            template.description = template.description.replace('90%', '95%');
          }

          if (template.label === SETTINGS_SMART_NOTIFICATIONS.presets.low_activity.label) {
            template.frequency = 'Daily';
            template.description = template.description.replace('35%', '20%');
          }

          return template;
        })
        .filter((template) => this.notificationPresets.includes(template.key))
        .reduce((acc, template, index) => {
          acc[index] = template;

          return acc;
        }, {});
    },
  },
  watch: {
    notifications: {
      handler() {
        this.checkNotifications();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    notificationExists(label) {
      return this.notifications.some((notification) => notification.name === label);
    },
    checkNotifications() {
      const hasEnabledNotification = this.notifications.length > 0;

      if (hasEnabledNotification && this.substepStatus !== 'completed') {
        this.$emit('completeSubstep');
      }

      if (!hasEnabledNotification && this.substepStatus === 'completed') {
        this.$emit('incompleteSubstep');
      }
    },
    async createNotification(notification, index) {
      try {
        this.submitting[index] = true;
        const params = {
          ...buildNotificationParams(notification.key),
          source: this.source,
        };
        const response = await SmartNotificationsSettingsResource.create(
          { organizationId: this.organization.id },
          params,
        );

        if (response.success) {
          this.$emit('reloadSubstep');
        } else if (response.errors) {
          this.$appMessage('Unexpected error. Please try again.');
        }
      } catch (error) {
        if (![401, 403].includes(error.status)) {
          this.$appMessage('Unhandled error. Please try again.');
        }
      } finally {
        this.submitting[index] = false;
      }
    },
    async deleteNotification(notification, index) {
      try {
        this.submitting[index] = true;
        const notificationId = this.notifications.find((n) => n.name === notification.label).id;

        if (!notificationId) {
          this.$emit('reloadSubstep');
        }

        const response = await SmartNotificationsSettingsResource.delete({
          organizationId: this.organization.id,
          smartNotificationId: notificationId,
        });

        if (response.success) {
          this.$emit('reloadSubstep');
        } else if (response.errors) {
          this.$appMessage('Unexpected error. Please try again.');
        }
      } catch (error) {
        if (![401, 403].includes(error.status)) {
          this.$appMessage('Unhandled error. Please try again.');
        }
      } finally {
        this.submitting[index] = false;
      }
    },
    closeDialog() {
      this.dialogDismissed = true;
    },
  },
};
